@import '../login/commonstyle.module.scss';

.rightsAndPrivacyPage {
  .description {
    @include barlow(30);

    @include target(mobile) {
      @include barlow(18);
    }

    em {
      font-weight: bold;
    }
  }
}

.desktop {
  .policy {
    margin-top: -7.5rem;
  }
}

.commonPolicy {
  h1 {
    @include merriweather(14);
    color: _palette(secondary);
    font-size: 1.875rem;
    margin: 1rem 0;
  }

  h2 {
    @include merriweather(14);
    color: _palette(secondary);
    font-size: 1.25rem;
    margin: 1.875rem 0 1rem;
  }

  h3 {
    @include merriweather(14);
    font-weight: bold;
    margin: 1rem 0 0.625rem;
  }

  li h3 {
    padding-top: 0.625rem;
  }

  p {
    line-height: 1.125rem;
    margin: 0.625rem 0;
    max-width: 100%;
  }

  ul {
    list-style-type: disc;
    margin: 0 0 0.625rem 1.875rem;
  }

  table {
    margin: 1em 0;
    width: 100%;
  }

  table,
  th,
  td {
    border: 0.0625rem solid black;
    text-align: left;
  }

  th,
  td {
    padding: 0.25em 0.5em 0.25em 1em;
  }

  caption {
    margin-bottom: 0.25em;
  }
}

.policy {
  @extend .commonPolicy;
  box-sizing: border-box;
  margin: auto;
  max-width: $desktopContentWidth;
  width: 100%;
}

.contentSummary {
  @include barlow(14);
  background-color: white;
  border: 0.0625rem solid black;
  border-radius: 5px;
  margin: 1.6rem 0;
  padding: 1.6rem;

  h2 {
    color: black !important;
    margin: 0 0 0.625rem !important;
    text-transform: uppercase;
  }

  h4 {
    color: black !important;
    margin: 0 0 0.625rem !important;
    text-transform: uppercase;
  }

  ol {
    list-style-type: decimal;
    margin-left: 1.6rem;

    li {
      @include merriweather(20);
      color: _palette(secondary);

      @include target(mobile) {
        @include merriweather(14);
      }
    }
  }
}

.smallPage {
  .policy {
    margin-top: 0 !important;
    padding: 0.3rem !important;

    h3 {
      @include merriweather(22);
      margin: 0 !important;
      padding: 0 !important;
    }

    h4 {
      margin: 0 0 0.625rem -0.3rem !important;
    }

    ol {
      margin-left: 0.625rem;

      li {
        font-size: 0.875rem;
      }
    }
  }
}

@include target(tablet) {
  .page {
    .description,
    h2 {
      display: block !important;
    }
  }
}
